module.exports = __webpack_public_path__ + "img/poorter_hotel-114.6430d8fa.jpg";